<div class="loghi-box">
    <p-carousel [value]="images_loghi"
                [numVisible]="6"
                [numScroll]="1"
                [circular]="true"
                [showIndicators]="false"
                [autoplayInterval]="2500"
                [responsiveOptions]="responsiveOptions"
                contentClass="loghi-carousel"
    >
        <ng-template let-item pTemplate="item">
            <div class="text-center">
            <img [src]="item.imgSrc" [alt]="item.name" width="64" height="42">
            </div>
        </ng-template>
    </p-carousel>
    <div class="button-box">
        <app-orange-button text="Start your Journey Now" (action)="goToOrderFlow()" />
    </div>
</div>